import { useContext } from "react";

import {
  Box,
  alpha,
  Stack,
  Divider,
  IconButton,
  Tooltip,
  styled,
  useTheme,
  useMediaQuery
} from "@mui/material";
import HeaderButtons from "./Buttons";
import HeaderSearch from "./Search";
import HeaderMenu from "./Menu";
import { SidebarContext } from "../../../src/contexts/SidebarContext";
import MenuTwoToneIcon from "@mui/icons-material/MenuTwoTone";
import CloseTwoToneIcon from "@mui/icons-material/CloseTwoTone";
import Logo from "../../components/Logo";
import { LogoCoinhouseMobile } from "../../components/Logo/LogoCoinhouse";
import { Menu } from "react-admin";

const HeaderWrapper = styled(Box)(
  ({ theme }) => `
        height: ${theme.header.height};
        color: ${theme.header.textColor};
        padding: ${theme.spacing(0, 2)};
        right: 0;
        z-index: 6;
        background-color: ${alpha(theme.header.background, 0.85)};
        backdrop-filter: blur(12px);
        position: fixed;
        justify-content: space-between;
        width: 100%;
        @media (min-width: ${theme.breakpoints.values.lg}px) {
            left: ${theme.sidebar.width};
            width: auto;
        }
`
);

function Header() {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <HeaderWrapper
      display="flex"
      alignItems="center"
      sx={{
        boxShadow: theme.header.boxShadow,
        borderBottom: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Stack
        direction="row"
        divider={<Divider orientation="vertical" flexItem />}
        alignItems="center"
        spacing={2}
      >
        {/*          <HeaderSearch /> */}
        {isMobile && <LogoCoinhouseMobile color="black" />}
      </Stack>

      <Box display="flex" alignItems="center">
        <HeaderMenu />
        <HeaderButtons />
        <Box
          component="span"
          sx={{
            ml: 2,
            display: { lg: "none", xs: "inline-block" },
          }}
        ></Box>
        <Box
          component="span"
          sx={{
            ml: 2,
            display: { lg: "none", xs: "inline-block" },
          }}
        >
          <Tooltip arrow title="Toggle Menu">
            <IconButton color="primary" onClick={toggleSidebar}>
              {!sidebarToggle ? (
                <MenuTwoToneIcon fontSize="small" />
              ) : (
                <CloseTwoToneIcon fontSize="small" />
              )}
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
    </HeaderWrapper>
  );
}

export default Header;
